import Swal from "sweetalert2";
import theme from "../theme/theme";

const showSweetAlert = (text, callback = null) => {
  Swal.fire({
    text: text,
    confirmButtonText: "موافق",
    confirmButtonColor: theme.colors.primary,
  }).then((result) => {
    if (result.isConfirmed && typeof callback === "function") {
      callback();
    }
  });
};

export default showSweetAlert;